module.exports = __webpack_public_path__ + "img/1 luis-teran-circulo.faf09c1b.png";